import DropdownMenu from 'emerald-ui/lib/DropdownMenu';
import DropdownItem from 'emerald-ui/lib/DropdownItem';
import Icon from 'emerald-ui/lib/Icon';
import populateDocs from './utils/populateDocs';

export default {
  ...populateDocs([{ component: DropdownMenu, componentName: 'DropdownMenu' }], 'DropdownMenu'),
  description:
    'The DropdownMenu contains a list of DropdownItems for selecting options. ' +
    'Note that the div with fixed height in the code samples below is for occupying ' +
    'space because the DropdownMenu is absolutely positioned, thus not occupying ' +
    'space in the DOM.',
  codeSamples: [
    {
      title: 'Default',
      scope: { DropdownItem, DropdownMenu },
      code: `<div>
  <div style={{ position: 'relative' }}>
    <DropdownMenu show style={{ display: 'block' }}>
      <DropdownItem header>Header</DropdownItem>
      <DropdownItem active>Action</DropdownItem>
      <DropdownItem>Other action</DropdownItem>
      <DropdownItem separator />
      <DropdownItem header>Other header</DropdownItem>
      <DropdownItem>Some other action</DropdownItem>
    </DropdownMenu>
  </div>
  <div style={{ height: '241px' }} />
</div>`,
    },
    {
      title: 'With icons',
      scope: { DropdownItem, DropdownMenu, Icon },
      code: `<div>
  <div style={{ position: 'relative' }}>
    <DropdownMenu
      show
      style={{ display: 'block' }}
      className="eui-dropdown-menu-icons"
    >
      <DropdownItem icon="file_upload">Bulk upload</DropdownItem>
      <DropdownItem>Show only my text</DropdownItem>
    </DropdownMenu>
    <DropdownMenu show style={{ display: 'block', marginTop: '120px' }}>
      <DropdownItem>
        Bulk upload <Icon aria-hidden name="file_upload" className="pull-right" />
      </DropdownItem>
      <DropdownItem>Show only my text</DropdownItem>
    </DropdownMenu>
  </div>
  <div style={{ height: '222px' }} />
</div>`,
    },
  ],
};
